export const sections = {
  description: 'o-levels-computing',
}
